import CanvasRenderer from "./canvas.js";
import SVGRenderer from "./svg.js";
import ObjectRenderer from "./object.js";
var stdin_default = { CanvasRenderer, SVGRenderer, ObjectRenderer };
export {
  stdin_default as default
};
